import { render } from "./SkeletonProfile.vue?vue&type=template&id=3575ab01"
import script from "./SkeletonProfile.vue?vue&type=script&lang=js"
export * from "./SkeletonProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__